import React, {useEffect, useMemo} from 'react';
import reportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const EventType = ({data}) => {
    const events = data.eventsType ?? []

    const top10 = useMemo(() => {
        const localData = events.slice(0, 10);

        return {
            labels: localData.map(item => reportUtils.formatText(item.name)),
            values: localData.map(item => item.qty)
        };
    }, [events]);

    const eventToExport = useMemo(() => {
        return {
            labels: events.map(item => reportUtils.formatText(item.name)),
            values: events.map(item => item.qty)
        };
    }, [events]);

    useEffect(() => {
        if (top10.labels.length > 0) {
            GraphicUtils.barChart('event-type', top10.values, top10.labels);
        }

        if (eventToExport.labels.length > 0) {
            ReportUtils.createExportableTable(eventToExport.labels, eventToExport.values, `Tipo do evento`);
        }

    }, [top10, eventToExport]);

    useEffect(() => {

    }, [data]);

    return (
        <>
            <div className="chart-report" title={"Tipo do evento"}>
                <span id={`event-type-title`} className="chart-title " htmlFor={"event-type"} >Tipo do evento {eventToExport.labels.length > 9 ? "(TOP 10)" : "" }</span>
                <div className="mt-3" id={"event-type"}></div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default EventType;